var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "hamburger menu"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4532",
    x: 12,
    y: 7,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#8F9FA6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4535",
    x: 15,
    y: 15,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#8F9FA6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4534",
    x: 5,
    y: 7,
    width: 4,
    height: 2,
    rx: 1,
    fill: "#8F9FA6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4536",
    x: 5,
    y: 15,
    width: 7,
    height: 2,
    rx: 1,
    fill: "#8F9FA6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 17",
    cx: 11,
    cy: 8,
    r: 2,
    stroke: "#8F9FA6",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 18",
    cx: 14,
    cy: 16,
    r: 2,
    stroke: "#8F9FA6",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon_filter.d1de3f6a20c7896470544d50407dfbb3.svg";
export { ForwardRef as ReactComponent };